/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ListLocationShareResponse {
  items?: Resource[];
  next?: Links;
}

export interface ListPoliciesResponse {
  items?: Policy[];
  next?: Links;
}

export interface ListPoliciesForUserResponse {
  policies?: Policy[];
}

export interface ListPoliciesForGroupResponse {
  policies?: Policy[];
}

export interface ListPoliciesForRoleResponse {
  policies?: Policy[];
}

export interface PatchGroupPolicyRequest {
  group?: string | SRN;
  policies?: (string | SRN)[];
}

export interface PatchRolePolicyRequest {
  role?: string | SRN;
  policies?: (string | SRN)[];
}

export interface PatchGroupUserRequest {
  group?: string | SRN;
  users?: (string | SRN)[];
}

export interface ListGrantsForUserResponse {
  items?: GrantDetails[];
  _links?: Links;
}

export interface GrantDetails {
  grantType?: GrantType;
  resource?: SRN;
  /**
   * Epoch timestamp in milliseconds for when the grant is effective
   * @format int64
   * @example 1676324608
   */
  effective?: number;
  /**
   * Epoch timestamp in milliseconds for when the grant is expired
   * @format int64
   * @example 1676344608
   */
  expiration?: number;
}

export interface ListGroupsForUserResponse {
  groups?: (string | SRN)[];
}

export interface ListUsersForGroupResponse {
  users?: (string | SRN)[];
}

export interface PutPolicyRequest {
  policy?: Policy;
}

export interface PutGroupResourceRequest {
  items?: GroupResource[];
}

export interface GroupResource {
  srn?: string | SRN;
  defaultAccount?: string | SRN;
  tags?: Tag[];
}

export interface PutRoleResourceRequest {
  items?: RoleResource[];
}

export interface RoleResource {
  srn?: string | SRN;
  prefix?: (string | SRN)[];
  tags?: Tag[];
  context?: Tag[];
  isStringFormat?: boolean;
}

export interface PolicyStatement {
  id?: string;
  effect?: 'allow' | 'deny';
  actions?: string;
  resources?: string;
}

export interface Policy {
  version?: string;
  id?: string;
  statements?: PolicyStatement[];
}

export interface PutUserResourceRequest {
  items?: UserResource[];
}

export interface UserResource {
  srn?: string | SRN;
  defaultAccount?: string | SRN;
  tags?: Tag[];
}

export interface QueryResultsPage {
  items?: (SRNStringQueryResult | SRNModelQueryResult)[];
  _links?: Links;
}

export interface Links {
  next?: string;
  previous?: string;
}

export interface SRN {
  root: SRNRoot;
  components?: SRNComponent[];
}

export interface SRNRoot {
  version: number;
  rootId?: string;
  service: 'core' | 'iam';
}

export interface SRNComponent {
  id?: string;
  kind: 'user' | 'group' | 'policy' | 'location' | 'device';
}

export interface PutIdQueryRequest {
  queries: IdQuery[];
}

export interface PutListQueryRequest {
  query: ListQuery;
}

export interface PutUsersQueryRequest {
  query: UserQuery;
}

export interface PutQueryRequest {
  /**
   * Number of items to return per page. Only applies to ListQuery. Read more about [pagination](https://librarian-regionals.smartthingsgdev.com/docs/index.html#pagination)
   * @default 100
   */
  limit?: number;
  queries: (IdQuery | ListQuerySRNString | ListQuerySRNModel)[];
}

export type Query = object;

export type IdQuery = Query & {
  service: string;
  kind: string;
  id: string;
};

export type ListQuery = Query & {
  /** The SRN prefix of the resources to return.  For example: Location SRNs are of the form 'st1:core:&lt;accountId&gt;:location/&lt;locationId&gt;'.  If interested in locations on account 'cca804f6-c86c-43a8-af2a-e1e577c6ae56', the prefix would be: 'st1:core:cca804f6-c86c-43a8-af2a-e1e577c6ae56' */
  prefix?: string | SRN;
  /** If set to true then include tag key/value pairs in response */
  includeTags?: boolean;
  /**
   * The kinds of resources to include in the response
   * @example "location"
   */
  kinds?: string;
  /** This is a list of actions that the principal must have on a resource in order for that resource to be included in the response.  While we do allow use of a wildcard (&#42;) in actions, we strongly discourage using wildcards, as it is asking the question 'does this principal have access to all possible actions with this prefix?'.  Instead of asking that, you should list the specific fine grained actions that you're interested in.  For example: instead of asking about action 'r:devices:&#42;' ask about 'r:devices:foo' and 'r:devices:bar' */
  actions?: string[];
  /** This is a list of actions that will be checked in addition to the 'actions' list, with the difference being that this list does not filter the result.  Resources lacking these actions will still be included in the response, and the 'allowed' list for each returned resource will identify which of these actions are allowed for the principal on that specific resource.  If an action is not present in the allowed list, then that action is denied. */
  inquire?: string[];
  /**
   * Limit the number of results per page.  Default: 100
   * @example 100
   */
  limit?: number;
  subquery?: ListSubQuery;
};

export type ListQuerySRNString = ListQuery & {
  principal: string;
  prefix: string;
};

export type ListQuerySRNModel = ListQuery & {
  principal: SRN;
  prefix: SRN;
};

export interface ListSubQuery {
  /** The kinds of resources to include in the response */
  kinds?: string[];
  /** This is a list of actions that the principal must have on a resource in order for that resource to be included in the response.  While we do allow use of a wildcard (&#42;) in actions, we strongly discourage using wildcards, as it is asking the question 'does this principal have access to all possible actions with this prefix?'.  Instead of asking that, you should list the specific fine grained actions that you're interested in.  For example: instead of asking about action 'r:devices:&#42;' ask about 'r:devices:foo' and 'r:devices:bar' */
  actions?: string[];
  /** This is a list of actions that will be checked in addition to the 'actions' list, with the difference being that this list does not filter the result.  Resources lacking these actions will still be included in the response, and the 'allowed' list for each returned resource will identify which of these actions are allowed for the principal on that specific resource.  If an action is not present in the allowed list, then that action is denied. */
  inquire?: string[];
  /** If set to true then include tag key/value pairs in response */
  includeTags?: boolean;
  /**
   * Limit the number of results per page.  Default: 100
   * @example 100
   */
  limit?: number;
  /**
   * If true, the sub-query results are aggregated, flattened, and returned WITHOUT super-query items, with a single page key that
   * paginates across both the super and sub queries.
   * This can be useful if you are executing a nested list query, are only interested in sub-query results, and want SIAM
   * to handle the nested pagination required.
   *
   * WARNING: If set to true, the response body may contain a partially filled or empty page, yet have a next page key. In addition,
   * the resulting pagination links can be very large, since they track both super query and sub query state.
   * @example false
   */
  returnSubqueryOnly?: boolean;
}

export type UserQuery = Query & {
  /**
   * Resource is either a string representation or an object representation of an SRN.
   * @example "st1:core::location/e37c2a90-449a-4a6f-ab51-5982e0bfe8d6"
   */
  resource:
    | string
    | {
        service: string;
        kind: string;
        id: string;
      };
  /** Actions is a filter to limit users returned to those that are able to perform these actions on the specified resource */
  actions?: string[];
  /**
   * Number of items to return per page. Read more about [pagination](https://librarian-regionals.smartthingsgdev.com/docs/index.html#pagination)
   * @default 100
   */
  limit?: number;
};

export type PatchTagsRequestSRNString = {
  srn?: string;
  tags?: Tag[];
};

export type PatchTagsRequestSRNModel = {
  srn?: SRN;
  tags?: Tag[];
};

export interface PutResourceRequest {
  resources?: (
    | SRNStringWithMetadata
    | SRNModelWithMetadata
    | SRNStringTree
    | SRNModelTree
    | (SRNStringWithMetadata & SRNModelWithMetadata & SRNStringTree & SRNModelTree)
  )[];
}

export type Resource = object;

export interface SRNQueryResult {
  tags?: Tag[];
  context?: Tag[];
  attributes?: Attribute[];
  /** These are actions that are allowed for the principal on this resource.  *** This is not an exhaustive list of all actions that are allowed ***  This only includes actions that were listed in the 'actions' or 'inquire' lists on the request.  By the nature of the 'actions' being a filter, they will always be included in the allowed list.  'inquire' actions are only included if they are allowed for the principal on the resource. */
  allowed?: string[];
}

export type SRNStringQueryResult = SRNQueryResult & {
  /**
   * SmartThings Resource Name
   * @example "st1:core:f4479d70-1070-43db-a841-1f109ed3cfa7:location/b983d79d-d65c-4dae-8526-0477ffabb5f2"
   */
  srn: string;
  tags?: Tag[];
  context?: Tag[];
  attributes?: Attribute[];
  /** These are actions that are allowed for the principal on this resource.  *** This is not an exhaustive list of all actions that are allowed ***  This only includes actions that were listed in the 'actions' or 'inquire' lists on the request.  By the nature of the 'actions' being a filter, they will always be included in the allowed list.  'inquire' actions are only included if they are allowed for the principal on the resource. */
  allowed?: string[];
};

export type SRNModelQueryResult = SRNQueryResult & {
  srn?: SRN;
};

export type SRNWithMetadata = Resource & {
  /** @maxLength 10 */
  tags?: Tag[];
};

export type SRNStringWithMetadata = SRNWithMetadata & {
  srn?: string;
};

export type SRNModelWithMetadata = SRNWithMetadata & {
  srn?: SRN;
};

export type SRNStringTree = Resource & {
  parent?: string;
  children?: SRNStringBranch[];
};

export interface SRNStringBranch {
  srn?: SRNStringWithMetadata;
  children?: SRNStringBranch[];
}

export type SRNModelTree = Resource & {
  parent?: SRN;
  children?: SRNModelBranch[];
};

export interface SRNModelBranch {
  srn?: SRNModelWithMetadata;
  children?: SRNModelBranch[];
}

export interface Attribute {
  val: number;
  kind: number;
  value?: string | SRN;
}

export interface Tag {
  /**
   * @minLength 3
   * @maxLength 25
   */
  name: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  value: string;
}

export interface PermissionCheckInvalidRequest {
  error?: string;
  message?: string;
}

export type PermissionCheckRequest = object;

export type PermissionCheckSRNStringRequest = PermissionCheckRequest & {
  principal?: string;
  resources?: PermissionCheckResourceSNRString[];
};

export type PermissionCheckSRNModelRequest = PermissionCheckRequest & {
  principal?: SRN;
  resources?: PermissionCheckResourceSNRModel[];
};

export type PatchShareLocationRequest = object;

export type PatchShareLocationSRNStringRequest = PatchShareLocationRequest & {
  location?: string;
  users?: string[];
};

export type PatchShareLocationSRNModelRequest = PatchShareLocationRequest & {
  location?: SRN;
  users?: SRN[];
};

export interface GrantSRNModelRequest {
  /** @maxItems 10 */
  users?: SRN[];
  resource?: SRN;
  grantType?: GrantType;
}

export interface GrantSRNStringRequest {
  /** @maxItems 10 */
  users?: string[];
  resource?: string;
  grantType?: GrantType;
}

export enum GrantType {
  Admin = 'admin',
  Share = 'share',
  Restrictedshare = 'restrictedshare',
  Orgadmin = 'orgadmin',
  Orgdeveloper = 'orgdeveloper',
  Cast = 'cast',
  Mfuadmin = 'mfuadmin',
  Mfuinstaller = 'mfuinstaller',
  Mfudelegatedinstaller = 'mfudelegatedinstaller',
  Mfutenant = 'mfutenant',
  Assumerole = 'assumerole',
}

export interface BatchGrantSRNModelRequest {
  /** @maxItems 202 */
  add?: GrantSRNModelRequest[];
  /** @maxItems 202 */
  remove?: GrantSRNModelRequest[];
}

export interface BatchGrantSRNStringRequest {
  /** @maxItems 202 */
  add?: GrantSRNStringRequest[];
  /** @maxItems 202 */
  remove?: GrantSRNStringRequest[];
}

export type PatchGrantRequest = object;

export type PatchGrantSRNModelRequest = PatchGrantRequest & {
  resource?: SRN;
  users?: SRN[];
};

export type PatchGrantSRNStringRequest = PatchGrantRequest & {
  resource?: string;
  users?: string[];
};

export interface PermissionCheckResource {
  hints?: string[];
  actions?: string[];
  /** @default false */
  returnAllowed?: boolean;
  /** @default false */
  includeTags?: boolean;
}

export type PermissionCheckResourceSNRModel = PermissionCheckResource & {
  resource?: SRN;
};

export type PermissionCheckResourceSNRString = PermissionCheckResource & {
  resource?: string;
};

export type PermissionCheckResponse = object;

export type AllowedPermissionCheckResponse = PermissionCheckResponse & {
  allowed?: (PermissionAllowedSRNModel | PermissionAllowedSRNString)[];
  authorizations?: Authorization[];
};

export type DeniedPermissionCheckResponse = PermissionCheckResponse & {
  items?: (PermissionDeniedSRNModel | PermissionDeniedSRNString)[];
  allowed?: (PermissionAllowedSRNModel | PermissionAllowedSRNString)[];
  authorizations?: Authorization[];
};

export interface Authorization {
  scope?: string[];
}

export interface PermissionAllowed {
  tags?: string[];
  actions?: string[];
}

export type PermissionAllowedSRNModel = PermissionAllowed & {
  resource?: SRN;
};

export type PermissionAllowedSRNString = PermissionAllowed & {
  resource?: string;
};

export interface PermissionDenied {
  debug?: PermissionDeniedDebug;
  tags?: string[];
  actions?: string[];
}

export type PermissionDeniedSRNModel = PermissionDenied & {
  resource?: SRN;
};

export type PermissionDeniedSRNString = PermissionDenied & {
  resource?: string;
};

export type PermissionDeniedDebug = object;

export type CastResourceRequest = {
  principal?: SRN | string;
  source?: SRN | string;
  targets?: (SRN | string)[];
};

export type CastResourceResponse = SRN[];

export interface ListCastResponse {
  items?: SRN[];
  _links?: Links;
}

export type ChangeTagsPayload = PatchTagsRequestSRNString | PatchTagsRequestSRNModel;

export type CreateOrUpdateResourcePayload = PutResourceRequest;

export interface DeleteResourceParams {
  /**
   * SmartThings Resource Name of the Resource to delete.
   * For a Device this would follow a pattern like `st1:core::device:<device uuid>`
   */
  srn: string;
  /**
   * SmartThings Resource Version.
   * This is only required if _not_ using the `srn` parameter.
   */
  version?: string;
  /**
   * SmartThings Resource Service.
   * This is only required if _not_ using the `srn` parameter.
   */
  service?: string;
  /**
   * SmartThings Resource Kind.
   * This is only required if _not_ using the `srn` parameter.
   */
  kind?: string;
  /**
   * SmartThings Resource ID.
   * This is only required if _not_ using the `srn` parameter.
   */
  id?: string;
}

export interface ListPoliciesParams {
  /** Policy IAM Root Resource Name */
  root: string;
}

export interface DeletePolicyParams {
  /** Policy IAM Resource Name */
  srn: string;
}

export interface GetPoliciesForGroupParams {
  /** Group IAM Resource Name */
  group: string;
  /** Page state */
  page?: string;
  /**
   * Response format of either String or Model
   * @default "string"
   */
  format?: 'string' | 'model';
}

export interface DeleteGroupPoliciesParams {
  /** SIAM Group SRN String */
  group: string;
  policy?: string[];
}

export interface GetUsersForGroupParams {
  /** Group IAM Resource Name */
  group: string;
  /**
   * Response format of either String or Model
   * @default "string"
   */
  format?: 'string' | 'model';
  /** Page state */
  page?: string;
}

export interface DeleteUsersFromGroupParams {
  /** Group IAM Resource Name */
  group: string;
  /** User IAM Resource Name */
  user: string[];
}

export interface DeleteRoleParams {
  /** Role SRN */
  srn: string;
}

export interface GetPoliciesForRoleParams {
  /** Role IAM Resource SRN */
  role: string;
  /** Page state */
  page?: string;
  /**
   * Response format of either String or Model
   * @default "string"
   */
  format?: 'string' | 'model';
}

export interface DeleteRolePoliciesParams {
  /** SIAM Role SRN String */
  role: string;
  policy?: string[];
}

export interface GetGroupsForUserParams {
  /** User IAM SmartThings Resource Name */
  user: string;
  /**
   * Response type of either String or Model
   * @default "string"
   */
  type?: 'string' | 'model';
  /** Page state */
  page?: string;
}

export interface GetPoliciesForUserParams {
  /** User IAM SmartThings Resource Name */
  user: string;
  /** Page state */
  page?: string;
}

export interface GetGrantsForUserParams {
  /** User IAM SmartThings Resource Name */
  user: string;
  /** Resource SRN prefix */
  prefix: string;
  /** Page state */
  page?: string;
  /**
   * Response SRN format
   * @default "string"
   */
  format?: 'string' | 'model';
  /**
   * Number of items to return per page. Read more about [pagination](https://librarian-regionals.smartthingsgdev.com/docs/index.html#_pagination)
   * @default 100
   */
  limit?: number;
}

export type CheckUpdatePayload = PermissionCheckSRNStringRequest | PermissionCheckSRNModelRequest;

export type CheckExternalUpdatePayload = PermissionCheckSRNStringRequest | PermissionCheckSRNModelRequest;

export type ShareLocationPartialUpdatePayload = PatchShareLocationSRNStringRequest | PatchShareLocationSRNModelRequest;

export interface ShareLocationDeleteParams {
  /** Location Resource Name */
  location: string;
  /** User Resource Name */
  user: string;
}

export interface ShareLocationListParams {
  /** Location Resource Name */
  location: string;
  /** Page state */
  page?: string;
  /**
   * Response format of either String or Model
   * @default "string"
   */
  format?: 'string' | 'model';
}

export type GrantUpdatePayload = BatchGrantSRNModelRequest | BatchGrantSRNStringRequest;

export interface GrantDetailParams {
  /** Resource SRN used in the original Grant */
  resource: string;
  /**
   * Number of items to return per page. Read more about [pagination](https://librarian-regionals.smartthingsgdev.com/docs/index.html#pagination)
   * @default 100
   */
  limit?: number;
  /** Optional next page state key */
  page?: string;
  /**
   * Optional user or partner SRN.  When provided, the response will be limited to that specific user or partner
   * @example "st1:iam::user/d630a88c-256f-465d-9278-1cd86f428176"
   */
  principal?: string;
  /** Grant Type */
  grantType:
    | 'admin'
    | 'share'
    | 'restrictedshare'
    | 'orgadmin'
    | 'orgdeveloper'
    | 'cast'
    | 'mfuadmin'
    | 'mfuinstaller'
    | 'mfudelegatedinstaller'
    | 'mfutenant'
    | 'assumerole';
}

export type GrantPartialUpdatePayload = PatchGrantSRNModelRequest | PatchGrantSRNStringRequest;

export interface GrantDeleteParams {
  /** User IAM SmartThings Resource Name. Allows repeated user parameter for multiple SRNs */
  user: string[];
  /** Resource SRN used in the original Grant */
  resource: string;
  /** Grant Type */
  grantType:
    | 'admin'
    | 'share'
    | 'restrictedshare'
    | 'orgadmin'
    | 'orgdeveloper'
    | 'cast'
    | 'mfuadmin'
    | 'mfuinstaller'
    | 'mfudelegatedinstaller'
    | 'mfutenant'
    | 'assumerole';
}

export interface CastResourcesListParams {
  /** user SRN e.g. st1:iam::user/c8a84ad5-bdeb-4d12-9548-132a404688f0 */
  user: string;
  /** Maximum number of results per page */
  limit?: string;
  /** Page state */
  page?: string;
}

export interface CastParentsListParams {
  /** resource SRN e.g. st1:core::device/c8a84ad5-bdeb-4d12-9548-132a404688f0 */
  srn: string;
  /** Maximum number of results per page */
  limit?: string;
  /** Page state */
  page?: string;
}

export interface CastUsersListParams {
  /** resource SRN e.g. st1:core::device/c8a84ad5-bdeb-4d12-9548-132a404688f0 */
  srn: string;
  /** Maximum number of results per page */
  limit?: string;
  /** Page state */
  page?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = 'https://siam-regionald.smartthingsgdev.com';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await (responseFormat !== 'json'
          ? response[responseFormat]()
          : response.text().then((text) => {
              try {
                return JSON.parse(text);
              } catch (e) {
                return text;
              }
            })
        )
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title SIAM
 * @version 0.0.3
 * @baseUrl https://siam-regionald.smartthingsgdev.com
 *
 * SmartThings Identity and Access Management (SIAM).  You
 * can learn more about SIAM at
 * [https://github.ecodesamsung.com/iot/siam](https://github.ecodesamsung.com/iot/siam)
 */
export class SiamApi<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  resource = {
    /**
     * @description Query by IDs for resources. The request is executed in the region it is received in. The format of the SRNs in the response, either string or object format, will be determined by the format of the SRNs in the request.
     *
     * @tags resource
     * @name QueryResourceId
     * @summary Query by IDs for resources.
     * @request PUT:/resource/query/id
     * @secure
     */
    queryResourceId: (data: PutIdQueryRequest, params: RequestParams = {}) =>
      this.request<QueryResultsPage, void>({
        path: `/resource/query/id`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List resources based on an SRN prefix and one or more actions. Answers the question: "For the given authentication or principal, for what resources of this kind with this parent can these actions be performed?". For example: list the locations (kind: 'location') for which a user (principal) has read devices (action: 'r:devices') on any account (prefix: 'st1:core::'). The format of the SRNs in the response, either string or object format, will be determined by the format of the prefix SRN(s) in the request. IE: if an object format SRN is provided, then object format SRNs will be returned. If a string format SRN is provided, then a string format SRN is returned. If a principal can be extracted from the authentication provided then any principal in the request body will be ignored.  If the authentication provided does not include a principal, for example if a service token is used, then the principal field must be populated. If a subquery is included, it will be executed for each result in the list query. Pagination for each subquery must be handleded separately.
     *
     * @tags resource
     * @name QueryResourceList
     * @summary List query for resource kinds.
     * @request PUT:/resource/query/list
     * @secure
     */
    queryResourceList: (data: PutListQueryRequest, params: RequestParams = {}) =>
      this.request<QueryResultsPage, void>({
        path: `/resource/query/list`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Look up list of users that have access to the specified resource and actions. The format of the SRNs in the response, either string or object format, will be determined by the format of the SRNs. Under certain unusual circumstances (such as a user with both admin and share grants on a location), there may be duplicate users between response pages. Please either make sure operations done with responses from this API are idempotent, or guard against doing the operation twice for a user.
     *
     * @tags resource
     * @name QueryUsers
     * @summary Query for user records
     * @request PUT:/resource/query/users
     * @secure
     */
    queryUsers: (data: PutUsersQueryRequest, params: RequestParams = {}) =>
      this.request<QueryResultsPage, void>({
        path: `/resource/query/users`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags resource
     * @name QueryResources
     * @summary Query for resource records.
     * @request PUT:/resource/query
     * @secure
     */
    queryResources: (data: PutQueryRequest, params: RequestParams = {}) =>
      this.request<QueryResultsPage, void>({
        path: `/resource/query`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  core = {
    /**
     * No description
     *
     * @tags resource
     * @name ChangeTags
     * @summary Manage tags for a resource
     * @request PATCH:/core/resource/tags
     * @secure
     */
    changeTags: (data: ChangeTagsPayload, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/core/resource/tags`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags resource
     * @name CreateOrUpdateResource
     * @summary Create or update resource records
     * @request PUT:/core/resource
     * @secure
     */
    createOrUpdateResource: (data: CreateOrUpdateResourcePayload, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/core/resource`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description When a resource is deleted, if the resource has children then the children will be re-parented to this resources parent.
     *
     * @tags resource
     * @name DeleteResource
     * @summary Delete a resource record
     * @request DELETE:/core/resource
     * @secure
     */
    deleteResource: (query: DeleteResourceParams, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/core/resource`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Cast a source resource to a target resource for a user. Creates a copy aka shadow record of a resource to another name space and/or part of a resource tree. As part of the operation, SIAM executes a permission check on both the source and target resources with the principal. * "w:casts" action is required on the source. * "w:{kind}:{id}" action is required on the target.
     *
     * @tags cast
     * @name CastUpdate
     * @summary Cast a resource
     * @request PUT:/core/cast
     * @secure
     */
    castUpdate: (data: CastResourceRequest, params: RequestParams = {}) =>
      this.request<CastResourceResponse, void>({
        path: `/core/cast`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Lists shadow resources that a user created from a cast.
     *
     * @tags cast
     * @name CastResourcesList
     * @summary List shadow resources for a user
     * @request GET:/core/cast/resources
     * @secure
     */
    castResourcesList: (query: CastResourcesListParams, params: RequestParams = {}) =>
      this.request<ListCastResponse, void>({
        path: `/core/cast/resources`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Lists parent aka target resources where a source resource has been cast
     *
     * @tags cast
     * @name CastParentsList
     * @summary List resources where a source resource has been cast
     * @request GET:/core/cast/parents
     * @secure
     */
    castParentsList: (query: CastParentsListParams, params: RequestParams = {}) =>
      this.request<ListCastResponse, void>({
        path: `/core/cast/parents`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Lists users who have cast a source resource.
     *
     * @tags cast
     * @name CastUsersList
     * @summary List users who have cast a source resource
     * @request GET:/core/cast/users
     * @secure
     */
    castUsersList: (query: CastUsersListParams, params: RequestParams = {}) =>
      this.request<ListCastResponse, void>({
        path: `/core/cast/users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  iam = {
    /**
     * No description
     *
     * @tags policy
     * @name CreateOrUpdatePolicy
     * @summary Create or update a Policy
     * @request PUT:/iam/policy
     * @secure
     */
    createOrUpdatePolicy: (data: PutPolicyRequest, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/iam/policy`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags policy
     * @name ListPolicies
     * @summary List Policies
     * @request GET:/iam/policy
     * @secure
     */
    listPolicies: (query: ListPoliciesParams, params: RequestParams = {}) =>
      this.request<ListPoliciesResponse, void>({
        path: `/iam/policy`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags policy
     * @name DeletePolicy
     * @summary Delete Policy
     * @request DELETE:/iam/policy
     * @secure
     */
    deletePolicy: (query: DeletePolicyParams, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/iam/policy`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags group / policies
     * @name AddPolicyToGroup
     * @summary Add Policies to a Group
     * @request PATCH:/iam/group/policies
     * @secure
     */
    addPolicyToGroup: (data: PatchGroupPolicyRequest, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/iam/group/policies`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags group / policies
     * @name GetPoliciesForGroup
     * @summary List Policies assigned to a Group
     * @request GET:/iam/group/policies
     * @secure
     */
    getPoliciesForGroup: (query: GetPoliciesForGroupParams, params: RequestParams = {}) =>
      this.request<ListPoliciesForGroupResponse, void>({
        path: `/iam/group/policies`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags group / policies
     * @name DeleteGroupPolicies
     * @summary Delete one or more policies from a group
     * @request DELETE:/iam/group/policies
     * @secure
     */
    deleteGroupPolicies: (query: DeleteGroupPoliciesParams, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/iam/group/policies`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags group / users
     * @name AddUserToGroup
     * @summary Add Users to a Group
     * @request PATCH:/iam/group/users
     * @secure
     */
    addUserToGroup: (data: PatchGroupUserRequest, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/iam/group/users`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags group / users
     * @name GetUsersForGroup
     * @summary List Users that belong to a Group
     * @request GET:/iam/group/users
     * @secure
     */
    getUsersForGroup: (query: GetUsersForGroupParams, params: RequestParams = {}) =>
      this.request<ListUsersForGroupResponse, void>({
        path: `/iam/group/users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags group / users
     * @name DeleteUsersFromGroup
     * @summary Delete Users from a Group
     * @request DELETE:/iam/group/users
     * @secure
     */
    deleteUsersFromGroup: (query: DeleteUsersFromGroupParams, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/iam/group/users`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags role
     * @name CreateOrUpdateRole
     * @summary Create or update a Role
     * @request PUT:/iam/role
     * @secure
     */
    createOrUpdateRole: (data: PutRoleResourceRequest, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/iam/role`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags role
     * @name DeleteRole
     * @summary Delete Role
     * @request DELETE:/iam/role
     * @secure
     */
    deleteRole: (query: DeleteRoleParams, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/iam/role`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags role / policies
     * @name AddPolicyToRole
     * @summary Add Policies to a Role
     * @request PATCH:/iam/role/policies
     * @secure
     */
    addPolicyToRole: (data: PatchRolePolicyRequest, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/iam/role/policies`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags role / policies
     * @name GetPoliciesForRole
     * @summary List Policies assigned to a Role
     * @request GET:/iam/role/policies
     * @secure
     */
    getPoliciesForRole: (query: GetPoliciesForRoleParams, params: RequestParams = {}) =>
      this.request<ListPoliciesForRoleResponse, void>({
        path: `/iam/role/policies`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags role / policies
     * @name DeleteRolePolicies
     * @summary Delete one or more policies from a Role
     * @request DELETE:/iam/role/policies
     * @secure
     */
    deleteRolePolicies: (query: DeleteRolePoliciesParams, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/iam/role/policies`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name CreateUser
     * @summary Adds user to an account and sets up default Admin permissions
     * @request PUT:/iam/user
     * @secure
     */
    createUser: (data: PutUserResourceRequest, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/iam/user`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name GetGroupsForUser
     * @summary Lists groups that a user belongs to
     * @request GET:/iam/user/groups
     * @secure
     */
    getGroupsForUser: (query: GetGroupsForUserParams, params: RequestParams = {}) =>
      this.request<ListGroupsForUserResponse, void>({
        path: `/iam/user/groups`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name GetPoliciesForUser
     * @summary List Policies for a User
     * @request GET:/iam/user/policies
     * @secure
     */
    getPoliciesForUser: (query: GetPoliciesForUserParams, params: RequestParams = {}) =>
      this.request<ListPoliciesForUserResponse, void>({
        path: `/iam/user/policies`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
 * No description
 *
 * @tags user
 * @name GetGrantsForUser
 * @summary Lists active grants that a user has on resources that match a particular SRN prefix.
If a grant has expired, it will not be returned.
 * @request GET:/iam/user/grants
 * @secure
 */
    getGrantsForUser: (query: GetGrantsForUserParams, params: RequestParams = {}) =>
      this.request<ListGrantsForUserResponse, void>({
        path: `/iam/user/grants`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description (Deprecated user Grant API instead) Adds a user to location sharing
     *
     * @tags share
     * @name ShareLocationPartialUpdate
     * @summary (Deprecated) Adds a user to location sharing
     * @request PATCH:/iam/share/location
     * @deprecated
     * @secure
     */
    shareLocationPartialUpdate: (data: ShareLocationPartialUpdatePayload, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/iam/share/location`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description (Deprecated user Grant API instead) Removes a user from location sharing
     *
     * @tags share
     * @name ShareLocationDelete
     * @summary (Deprecated) Removes a user from location sharing
     * @request DELETE:/iam/share/location
     * @deprecated
     * @secure
     */
    shareLocationDelete: (query: ShareLocationDeleteParams, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/iam/share/location`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description (Deprecated user Grant API instead) Lists users shared with a location
     *
     * @tags share
     * @name ShareLocationList
     * @summary (Deprecated) Lists users shared with a location
     * @request GET:/iam/share/location
     * @deprecated
     * @secure
     */
    shareLocationList: (query: ShareLocationListParams, params: RequestParams = {}) =>
      this.request<ListLocationShareResponse, void>({
        path: `/iam/share/location`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Accepts a list of grants to apply and a list of grants to remove. Allows up to 202 grants to apply and 202 grants to remove. Allows up to 10 users per grant to apply or remove. The same grant, user, and resource, cannot be in both lists.
     *
     * @tags grant
     * @name GrantUpdate
     * @summary Batch grant and remove users' access to and from resources
     * @request PUT:/iam/grant
     * @secure
     */
    grantUpdate: (data: GrantUpdatePayload, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/iam/grant`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Lists users that have been granted access to a resource with the specified Grant Type.
     *
     * @tags grant
     * @name GrantDetail
     * @summary List User Grants for a Resource
     * @request GET:/iam/grant/{grantType}
     * @secure
     */
    grantDetail: ({ grantType, ...query }: GrantDetailParams, params: RequestParams = {}) =>
      this.request<QueryResultsPage, void>({
        path: `/iam/grant/${grantType}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Using an embedded strategy pattern, this endpoint creates an IAM Group with configured IAM Policies and assigns the user.  The strategy users the SRN resource information along with Grant Type to determine which configuration pattern to use.
     *
     * @tags grant
     * @name GrantPartialUpdate
     * @summary Grants User access to a Resource
     * @request PATCH:/iam/grant/{grantType}
     * @secure
     */
    grantPartialUpdate: (
      grantType:
        | 'admin'
        | 'share'
        | 'restrictedshare'
        | 'orgadmin'
        | 'orgdeveloper'
        | 'cast'
        | 'mfuadmin'
        | 'mfuinstaller'
        | 'mfudelegatedinstaller'
        | 'mfutenant'
        | 'assumerole',
      data: GrantPartialUpdatePayload,
      params: RequestParams = {},
    ) =>
      this.request<any, void>({
        path: `/iam/grant/${grantType}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Removes IAM Group access for a user based on a Grant Type and resource SRN.  During user grant removal, if there are no longer any users associated with the grant type for the given resource, any underlying IAM Group and Policy associates will also be removed.
     *
     * @tags grant
     * @name GrantDelete
     * @summary Removes Grant from a Resource
     * @request DELETE:/iam/grant/{grantType}
     * @secure
     */
    grantDelete: ({ grantType, ...query }: GrantDeleteParams, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/iam/grant/${grantType}`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  permission = {
    /**
     * @description Checks permissions. The format of the SRNs in the response, either string or object format, will be determined by the format of the SRNs in the request. If a principal can be extracted from the authentication provided, it will replace the principal in the request body.
     *
     * @tags permissions
     * @name CheckUpdate
     * @summary Checks permissions
     * @request PUT:/permission/check
     * @secure
     */
    checkUpdate: (data: CheckUpdatePayload, params: RequestParams = {}) =>
      this.request<
        AllowedPermissionCheckResponse | DeniedPermissionCheckResponse,
        void | PermissionCheckInvalidRequest
      >({
        path: `/permission/check`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Intended to be used externally by hubs to perform permission checks. Largely identical to the /permission/check endpoint, but this one only accepts device and hub api principaled tokens.  The format of the SRNs in the response, either string or object format, will be determined by the format of the SRNs in the request.  Cannot be invoked with a service token and any principal in the request body is ignored.  Because authorization check principals are not allowed, this permission check endpoint does not return authorization information.
     *
     * @tags permissions
     * @name CheckExternalUpdate
     * @summary Checks permissions for external principals
     * @request PUT:/permission/check/external
     * @secure
     */
    checkExternalUpdate: (data: CheckExternalUpdatePayload, params: RequestParams = {}) =>
      this.request<
        AllowedPermissionCheckResponse | DeniedPermissionCheckResponse,
        void | PermissionCheckInvalidRequest
      >({
        path: `/permission/check/external`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
}
